import { ConfirmationModal } from "./confirmation-modal";

interface DeleteConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message?: string;
  itemName?: string;
  isLoading?: boolean;
}

/**
 * Thin preset over ConfirmationModal — the app has exactly one confirm
 * dialog implementation; this only supplies delete-flavored defaults.
 */
export function DeleteConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  title = "Delete Confirmation",
  message = "Are you sure you want to delete this item?",
  itemName,
  isLoading = false,
}: DeleteConfirmationModalProps) {
  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title={title}
      message={message}
      itemName={itemName}
      footnote="This action cannot be undone."
      confirmText={isLoading ? "Deleting" : "Delete"}
      variant="danger"
      isLoading={isLoading}
    />
  );
}
